<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>{{text}}</p>
  <mat-form-field class="full-width">
    <input matInput placeholder="Phone number" name="phoneNumber" [disabled]="!isPinDisabled" [(ngModel)]="phone" [imask]="phoneMask" [unmask]="true" minlength="10" maxlength="15" require>
  </mat-form-field>
  <mat-form-field class="full-width">
    <input matInput placeholder="Code" name="pin" [(ngModel)]="pin" [disabled]="isPinDisabled" minlength="4" maxlength="4" require>
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial [disabled]="isLoading" color="primary">Cancel</button>

  <div [hidden]="!isPinDisabled" style="margin-left: 10px;">
    <button mat-raised-button (click)="onYesClick()" readonly="" color="accent"  [disabled]="phone == null || isLoading">Send code</button>
  </div>
  <div [hidden]="isPinDisabled" style="margin-left: 10px;">
    <button mat-raised-button (click)="onConfirmClick()" readonly="" color="accent" [disabled]="pin == null || pin == ''|| isLoading">Confirm</button>
  </div>
</div>
